import * as R from "ramda";
import {
  idx_data_pitch,
  idx_data_pitch_32,
  idx_data_pitch_16p,
  idx_data_pitch_64,
  idx_data_pitch_32p,
  idx_data_pitch_left,
  idx_data_pitch_left_32,
  idx_data_pitch_left_16p,
  idx_data_pitch_left_64,
  idx_data_pitch_left_32p,
  idx_data_pitch_right,
  idx_data_pitch_right_32,
  idx_data_pitch_right_16p,
  idx_data_pitch_right_64,
  idx_data_pitch_right_32p,
} from "../db/datafixtures/datafixtures";

export const specsheetParser = (appSettings) => (specsheet) => {
  if (specsheet) {
    const { hand } = specsheet;

     const pitch_measurement = appSettings.systemDefault.pitch_measurement;
    // const pitch_measurement =
    //   appSettings.systemDefault.pitch_measurement.indexOf("+") >= 0
    //     ? "32+"
    //     : "64";
    const pitchDS = R.pathOr(idx_data_pitch, [pitch_measurement])({
      32: idx_data_pitch_32,
      "16+": idx_data_pitch_16p,
      64: idx_data_pitch_64,
      "32+": idx_data_pitch_32p,
    });

    const pitch_leftDS = R.pathOr(idx_data_pitch_left, [pitch_measurement])({
      32: idx_data_pitch_left_32,
      "16+": idx_data_pitch_left_16p,
      64: idx_data_pitch_left_64,
      "32+": idx_data_pitch_left_32p,
    });

    const pitch_rightDS = R.pathOr(idx_data_pitch_right, [pitch_measurement])({
      32: idx_data_pitch_right_32,
      "16+": idx_data_pitch_right_16p,
      64: idx_data_pitch_right_64,
      "32+": idx_data_pitch_right_32p,
    });

    const parseF1Fields = R.pipe(
      R.pickBy((_, key) => key.indexOf("f1_") >= 0),
      R.mapObjIndexed((val, key) =>
        hand === "left_hander"
          ? R.path([key.replace("f1", "f2")])(specsheet)
          : val
      )
    )(specsheet);

    const parseF2Fields = R.pipe(
      R.pickBy((_, key) => key.indexOf("f2_") >= 0),
      R.mapObjIndexed((val, key) =>
        hand === "left_hander"
          ? R.path([key.replace("f2", "f1")])(specsheet)
          : val
      )
    )(specsheet);

    const thumbFields = R.pipe(R.pickBy((_, key) => key.indexOf("thm_") >= 0))(
      specsheet
    );

    const pitchesFields = {
      ...parseF1Fields,
      ...parseF2Fields,
      ...thumbFields,
    };

    const pitchesValues = R.pipe(
      R.pickBy(
        (_, key) =>
          key.indexOf("_lat") >= 0 ||
          key.indexOf("_rev") >= 0 ||
          key.indexOf("_for") >= 0
      ),
      R.mapObjIndexed((val, key) => {
        const searchPitchDS = R.pathOr(pitchDS, [key])({
          f1_lat: pitch_leftDS,
          f2_lat: pitch_rightDS,
        });

        const display_measurement =
          appSettings.systemDefault.display_measurement;
        return R.pipe(R.find(R.propEq("fraction", val)), (pitchVal) => {
          // console.log("pitchesPitchVal", pitchVal);
          return pitchVal
            ? display_measurement === "decimal"
              ? R.path([display_measurement])(pitchVal).toFixed(3)
              : R.path([display_measurement])(pitchVal)
            : "";
        })(searchPitchDS.filter((pitch) => pitch.fraction !== "---"));
      }),
      R.merge(pitchesFields)
    )(pitchesFields);

    return R.merge(specsheet, pitchesValues);
  } else {
    return specsheet;
  }
};
